<template>
  <div class="connecting">
    <!-- <h3>{{ pageTitle }}</h3> -->
    <div class="content" v-if="step === 'success'">
      <div class="common-title">
        Connecting your Amazon account
      </div>
      <div class="success-img-container">
        <img src="../../assets/images/img/success.png" alt="success" class="success-img">
      </div>
      <p class="success-text">Amazon Seller Account Connected.</p>
      <artmisads-button class="next-btn" @click="goNext">Next</artmisads-button>
    </div>
    <paymentMethod v-else-if="step === 'payment'" embedded />
    <div class="content" v-else>
      <div class="common-title">
        Connecting your Amazon account
      </div>
      <div class="common-content">
        We're establishing a secure handshake with Amazon Ads API.
      </div>
      <span class="loading-spinner" aria-hidden="true">
        <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
          <circle
            cx="24"
            cy="24"
            r="20"
            fill="none"
            stroke="#7D58E5"
            stroke-width="4"
            stroke-linecap="round"
            stroke-dasharray="94 126"
            transform="rotate(-90 24 24)"
          />
        </svg>
      </span>
      <p class="loading-text">Please be patient, this may take a while…</p>
    </div>
    <contextHolder />
  </div>
</template>
<script setup>
  import jwt from 'jsonwebtoken';
  import { ref, computed, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { notification } from 'ant-design-vue';

  import { profileApi } from '../../server/index'
  import { useUserInfoStore } from '../../storeData/index';
  import paymentMethod from './paymentMethod.vue';
  import { useSellerI18n } from '@/composables/useSellerI18n';

  const { st } = useSellerI18n();

  const store = useUserInfoStore();
  const [api, contextHolder] = notification.useNotification();
  const openNotification = description => {
    api.info({
      message: `Warning`,
      description: description,
      placement: 'topRight',
      duration: 10
    });
  };

  const props = defineProps(['goTo', 'title']);
  const route = useRoute();
  const PROFILE_CONNECTING_STEP_KEY = `${location.hostname}_profileConnectingStep`;
  const step = ref('');

  const saveStep = (value) => {
    if (value) {
      sessionStorage.setItem(PROFILE_CONNECTING_STEP_KEY, value);
    } else {
      sessionStorage.removeItem(PROFILE_CONNECTING_STEP_KEY);
    }
  };

  const restoreStep = () => {
    const savedStep = sessionStorage.getItem(PROFILE_CONNECTING_STEP_KEY);
    if (store.userInfo?.needBindPayment === 'Y' && (savedStep === 'payment' || !savedStep)) {
      step.value = 'payment';
      saveStep('payment');
      return true;
    }
    if (savedStep === 'success') {
      step.value = 'success';
      return true;
    }
    return false;
  };

  const pageTitle = computed(() => {
    if (step.value === 'payment') {
      return st('finance.paymentMethodRegistrationTitle');
    }
    return props.title ? props.title : 'Connecting your Amazon account';
  });

  const goNext = () => {
   
    const needBindPayment = store.userInfo?.needBindPayment;
    if(needBindPayment=='Y') {
      step.value = 'payment';
      saveStep('payment');
    } else {
      saveStep('');
      const timer = setTimeout(() => {
        // 新注册用户 有Dashboard权限, 直接跳转
        location.href = '/seller/dashboard';
        clearTimeout(timer);
      }, 300)
    }
    // step.value = 'payment';
  };

  async function completeProfile(amazonCode) {
    const params = JSON.parse(localStorage.getItem('userProfile'));
    if (!params) {
      props.goTo(1);
      return;
    }
    params.sellerProfile.amazonAuthorizationCode = amazonCode;
    const res = await profileApi.completeProfile(params);
    const { success, data, error } = res;
    if (success) {
      const menu = data.menu;
      const userToken = data.token;
      const artmisAdsUserData = jwt.decode(userToken);
      store.setUserInfo(artmisAdsUserData, userToken, menu);
      step.value = 'success';
      saveStep('success');
    } else {
      openNotification(error);
      const timer = setTimeout(() => {
        props.goTo(1);
        clearTimeout(timer);
      }, 500)
    }
    localStorage.removeItem('userProfile');
  }

  onMounted(() => {
    if (restoreStep()) {
      return;
    }
    const amazonCode = route.query.code;
    if (amazonCode) {
      completeProfile(amazonCode);
    }
  })

</script>
<style lang="less" scoped>
  .connecting {
    display: flex;
    flex-direction: column;
    margin-left: -90px;
    .loading-text{
      font-family: Sora;
font-weight: 400;
font-style: Regular;
font-size: 14px;
leading-trim: NONE;
width: 100% !important;
color: rgba(15, 6, 41, 0.3);
letter-spacing: 0%;
text-align: center;

    }
    .success-img-container{
      width: 110px;
      height: 110px;
    }
    .common-title{
      font-family: Sora;
font-weight: 700;
font-style: Bold;
font-size: 24px;

leading-trim: NONE;
// line-height: 100%;
letter-spacing: 0%;
text-align: center;
color: rgba(15, 6, 41, 1);
    }
    .common-content{
      font-family: Sora;
font-weight: 400;
font-style: Regular;
font-size: 16px;
leading-trim: NONE;

letter-spacing: 0%;
text-align: center;
color: rgba(15, 6, 41, 0.5);
margin: 12px auto;
    }
    .content {
      margin-top: 24px;
      width: 448px;
      min-height: 240px;
      padding: 40px 48px;
      background: var(--color-white);
      box-shadow: var(--section-box-shadow-2);
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .success-icon {
        width: 50px;
        height: 50px;
        background-color: var(--green-5);
        box-shadow: 0 0 0 7px var(--green-6);
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 22px;
        .icon {
          width: 32px;
          height: 32px;
          fill: rgba(255, 255, 255, 0.85);
        }
      }
      .success-text {
        font-family: Sora, sans-serif;
        font-size: 16px;
        font-weight: 600;
        color: var(--dark-1);
        text-align: center;
        line-height: 22px;
        margin-bottom: 24px;
        width: 100% !important;
      }
      .next-btn {
        width: 200px;
        height: 48px;
        border-radius: 24px;
        font-size: 16px;
        font-weight: 600;
        background-color: rgba(108, 61, 242, 1);
        color: #fff;
      }
      > p {
        margin-top: 16px;
        width: 239px;
        font-family: Sora, sans-serif;
        text-align: center;
        line-height: 20px;
      }
      .loading-spinner {
        width: 48px;
        height: 48px;
        margin: 16px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          width: 48px;
          height: 48px;
          display: block;
          transform-origin: center center;
          will-change: transform;
          backface-visibility: hidden;
          animation: connecting-spin 0.85s linear infinite;
        }
      }
    }
  }

  @keyframes connecting-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
